var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"text-xs-center",attrs:{"shrink":"","mx-2":"","pa-1":""}},[_c('p',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.person.relationName)+" ")]),_c('p',{staticClass:"mb-0 fw-600 f-1"},[_vm._v(" "+_vm._s(_vm.person.newName)+" ")]),_c('p',[_vm._v(_vm._s(_vm.person.age)+" "+_vm._s(_vm.ageOpt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }